module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Up-right-04d515cf64246df933839dcb9040784a.svg";